/**
 */
export enum ResizerScaleType {
  /**
   * Apply no scaling to Pixi app.
   */
  None,
  /**
   * Scale the PIXI.Stage.
   */
  Stage,
  /**
   * Scale the Pixi.Application view with CSS.
   */
  CSS
}
